(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tcc-blocks-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();
})();
